export default "__VITE_ASSET__CGPJxBP3__"